import {FC, ReactNode} from "react";
import {css, cx} from "@pandacss/css";
import {font} from "../style/typography.tsx";

interface Props {
    active?: boolean;
    onChange?: (active: boolean) => void;
    children: ReactNode;
}

const pillClass = css({
    padding: "8px 16px",
    gap: "8px",
    display: "flex",
    alignItems: "center",
    borderRadius: "18px",
    background: "neutral.700",
    border: "1px solid",
    borderColor: "neutral.100",
    color: "neutral.100",
    cursor: "pointer",

    "&.active": {
        background: "primary.500",
        borderColor: "primary.500",
        color: "neutral.100",
    }
})

const TogglePill: FC<Props> = ({active = false, onChange, children}) => {
    const handleClick = () => {
        if (onChange) {
            onChange(!active);
        }
    };

    return (
        <div className={cx(pillClass, font("body", "2", "semiBold"), active && "active")} onClick={handleClick}>
            {children}
        </div>
    );
}

export default TogglePill;